import { apiCall } from "./Interceptor";

const REGION_ALL = "/region/getAll/public";

const getAllRegion = async () => {
    const response = await apiCall.get(REGION_ALL);
    return response;
}

export default {
    getAllRegion,
};
